export enum ContactUserEvents {
    ClickContactLink = "Contact - Click Contact Link",
    OpenContactFormModal = "Contact - Open Contact Form Modal",
}
